import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  deleteCity,
  importPreProjects,
  updateCity,
  updatePreProjectCount,
} from '../mutations/preProjects.mutations'
import { fetchPreProjectCities } from '../queries/preProjects.queries'

export const PRE_PROJECT_CITIES_QUERY_KEY = ['pre-project-cities'] as const

export const usePreProjectCities = () =>
  useQuery({
    queryKey: PRE_PROJECT_CITIES_QUERY_KEY,
    queryFn: fetchPreProjectCities,
  })

export const useImportPreProjects = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: importPreProjects,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PRE_PROJECT_CITIES_QUERY_KEY })
    },
  })
}

export const useUpdatePreProjectCount = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updatePreProjectCount,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PRE_PROJECT_CITIES_QUERY_KEY })
    },
  })
}

export const useDeleteCity = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteCity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PRE_PROJECT_CITIES_QUERY_KEY })
    },
  })
}

export const useUpdateCity = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateCity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PRE_PROJECT_CITIES_QUERY_KEY })
    },
  })
}
